var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeaHexagon = function SvgIdeaHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    stroke: "url(#ideaHexagon_svg__a)",
    strokeWidth: 1.8,
    d: "M39.65 2.396a4.7 4.7 0 0 1 4.7 0l30.773 17.767a4.7 4.7 0 0 1 2.35 4.07v35.534a4.7 4.7 0 0 1-2.35 4.07L44.35 81.603a4.7 4.7 0 0 1-4.7 0L8.877 63.838a4.7 4.7 0 0 1-2.35-4.07V24.233a4.7 4.7 0 0 1 2.35-4.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M42 63.482c11.874 0 21.5-9.626 21.5-21.5s-9.626-21.5-21.5-21.5-21.5 9.626-21.5 21.5 9.626 21.5 21.5 21.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    fillRule: "evenodd",
    d: "M42 36.232c-3.154 0-5.75 2.644-5.75 5.956 0 .89.188 1.733.525 2.489l-1.37.61a7.6 7.6 0 0 1-.655-3.1c0-4.095 3.224-7.455 7.25-7.455s7.25 3.36 7.25 7.456a7.6 7.6 0 0 1-.654 3.098l-1.37-.61a6.1 6.1 0 0 0 .524-2.488c0-3.312-2.596-5.956-5.75-5.956M42.75 31.232v2.5h-1.5v-2.5zM52.75 42.732h-2.5v-1.5h2.5zM33.75 42.732h-2.5v-1.5h2.5zM50.131 34.91l-1.768 1.768-1.06-1.06 1.768-1.768zM35.637 36.679l-1.768-1.768 1.06-1.06 1.769 1.767z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    d: "M38 45.732h8a.75.75 0 0 1 .735.897l-.32 1.603h-8.83l-.32-1.603a.75.75 0 0 1 .735-.897M38.866 49.732l.396 2.373a.75.75 0 0 0 .74.627h4a.75.75 0 0 0 .74-.627l.395-2.373z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ideaHexagon_svg__a",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011427"
  })))));
};
export default SvgIdeaHexagon;